module.exports = __webpack_public_path__ + "media/images/flags/fj-397a48229d007c10885effc4f261fb7b.svg";